// extracted by mini-css-extract-plugin
export default {"wrapper":"HelpPage_wrapper__WJttx","tabContainer":"HelpPage_tabContainer__QfOyE","active":"HelpPage_active__5AFFv"};